<template>

  <div>

    <div class="d-print-none d-flex justify-content-center align-items-center p-3">

      <b-button class="mr-3" variant="primary" @click="getReportView()">
        <b-icon-arrow-clockwise class="mr-2"/>
        Atualizar

      </b-button>

      <b-button onclick="window.print()" variant="primary">
        <b-icon-printer class="mr-2"/>
        Imprimir
      </b-button>

    </div>

    <div id="container_report" :class="{'report-landscape':landscape}">


      <div class="h-100-header d-flex justify-content-center align-items-center" v-if="busy">

        <div class="loader">
          <div class="ball-scale-multiple">
            <div style="background-color: rgb(51,51,51);"></div>
            <div style="background-color: rgb(51,51,51);"></div>
            <div style="background-color: rgb(51,51,51);"></div>
          </div>
        </div>

      </div>

      <transition mode="out-in"
                  enter-active-class="animated fadeIn">

        <div v-show="!busy" class="fadeIn" id="content-report">

          <div v-html="reportHtml"></div>

        </div>

      </transition>


    </div>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";
import ui from "@/assets/scripts/ui";
import ApexCharts from "apexcharts";

function convert(text) {
  alert(text)
}

export default {
  mixins: [pageDefaultMixin],
  name: 'ReportView',
  data() {
    return {
      busy: true,
      title: "",
      logo: "",
      reportHtml: "",
      dateNow: "",
      user: "",
      pageTitle: "Relatório",
      chartArray: [],
      landscape: false,
    }
  },
  methods: {

    convert(text) {
      convert(text)
    },

    reportError(error) {

      this.status = "subject"

      if (error.response) {
        if (error.response.status === 401) {
          window.location.href = "/login?logout=yes";
        } else if (error.response.status === 500) {
          if (error.response.data) {
            if (error.response.data.message) {
              ui.msgError(this, 'Erro', error.response.data)
            } else {
              ui.msgError(this, error.response.data.general[0])
            }
          }
        }
      } else if (error !== '') {
        ui.msgError(this, "Erro", error)
      }
    },

    async getReportView() {

      this.busy = true

      //Remove outros gráficos gerados anteriormente
      for (let item of this.chartArray) {
        item.chart.destroy()
      }
      this.chartArray = []
      //--------------------------------------------

      let url = "general/report/generate?platform=web&type=R&format=html";

      Object.entries(this.$route.query).forEach(([key, value]) => {

        const valueConverted = decodeURI(value)

        if (key === 'title') {
          this.title = valueConverted
          this.pageTitle = this.title

          url += `&${key}=${valueConverted}`

        } else if (key === 'landscape') {
          this.landscape = valueConverted
        } else {
          url += `&${key}=${valueConverted}`
        }

      })

      await crudGeneral.get(url)
          .then(response => {

            const reportRender = ui.reportRender(response.data)
            this.reportHtml = reportRender.report

            if (reportRender.charts.length > 0) {

              setTimeout(() => {

                let i = 0

                for (const chart of reportRender.charts) {

                  this.chartArray.push({
                    id: chart.id,
                    chart: new ApexCharts(document.getElementById(chart.id), chart)
                  })

                  this.chartArray[i].chart.render()

                  i++

                }

              }, 100)

            }

            this.busy = false


          }).catch(error => this.reportError(error))

    }

  },
  async mounted() {


    //this.logo = ui.getTemplateLogo()
    //this.dateNow = ui.currentDateTime()
    //this.user = ui.getUser()

    ui.setFavicon("document")

    await this.getReportView()

  },
}
</script>
<style>
.table thead th {
  text-align: center;
  vertical-align: middle;
}

body {
  background-color: #363636;
}

#container_report {
  max-width: 1000px;
  background-color: #FFFFFF;
  margin: auto;
  padding: 15px;
  height: calc(100vh - 100px);
  overflow: auto;
}

.report-landscape{
  max-width: 100%;
}

@media print {

  body {
    background-color: #FFFFFF;
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }

  #container_report {
    height: 100%;
  }

  .apexcharts-toolbar {
    display: none !important;
  }

  @page {
    margin-top: 30px;
    margin-bottom: 20px;
  }

}
</style>
